import { jsx as _jsx } from "react/jsx-runtime";
import SlideInPage from '../SlideInPage/SlideInPage';
import InfoBox from '../InfoBox/InfoBox';
export const UnknownHash = () => {
    return (_jsx(SlideInPage, { mainHeading: "", showLeftIcon: true, children: _jsx(InfoBox, {}) }));
};
